import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid
} from 'recharts';

const AccountValue = ({ totals }) => {
  return (
    <div className="text-sm space-y-4">
      <div className="text-[#c1dbff] text-xl font-semibold">Detalles</div>

      <div className="bg-[#edf5fe] py-4  px-20 rounded-md w-full text-blue-900">
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={totals}>
            <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
            <XAxis dataKey="year" stroke="#032a61" fontWeight={700} fontSize={16} />
            <YAxis
              stroke="#032a61"
              tickLine={true}
              axisLine={true}
              width={80}
              tickFormatter={(value) =>
                value.toLocaleString('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 })
              }
            />
            <Tooltip
              formatter={(value) =>
                [`${value.toLocaleString('es-CO', { style: 'currency', currency: 'COP' })}`, 'Valor']
              }
              labelFormatter={(label) => `Año: ${label}`}
            />
            <Bar dataKey="amount" fill="#2151a1" radius={[4, 4, 0, 0]} barSize={50} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="bg-[#edf5fe] p-4 rounded-md">
        <div className="text-blue-900 font-semibold text-xl mb-3">Total por años</div>
        {totals.map((item) => (
          <div key={item.year} className="flex items-center text-blue-900 font-semibold">
            <span className="mr-2">{item.year}</span>
            <div className="flex-grow border-t border-dotted border-blue-900 mx-2" />
            <span>{item.amount.toLocaleString('es-CO')}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccountValue;
